'use client';

import dynamic from 'next/dynamic';
import { FindOnGlobeProvider } from './context';
import { FinderControlsUI } from './FinderControlsUI';
import GlobeLoadingScreen from './GlobeLoadingScreen';
import { useContext } from 'react';
import { FindOnGlobeContext } from './context';

const GlobeScene = dynamic(() => import('./GlobeScene'), { ssr: false });

const GlobeContent = () => {
  const FGC = useContext(FindOnGlobeContext);

  return (
    <div
      style={{
        position: 'relative',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#000',
        overflow: 'hidden',
        opacity: FGC.storesLoaded ? 1 : 0,
        transition: 'opacity 0.5s ease-in-out',
      }}
    >
      <GlobeScene className="globe-scene" />
      <FinderControlsUI />
    </div>
  );
};

const GlobeComp = () => {
  return (
    <FindOnGlobeProvider>
      <div
        style={{
          position: 'relative',
          height: '100vh',
          width: '100vw',
          backgroundColor: '#000',
          overflow: 'hidden',
        }}
      >
        <GlobeLoadingScreen />
        <GlobeContent />
      </div>
    </FindOnGlobeProvider>
  );
};

export default GlobeComp;
